import { ToolbarOption } from './htmlEditor.types'

export const getToolbarOptions = (
    options: ToolbarOption[]
): Array<string | { list: string }>[] => {
    const textFormatting = ['bold', 'italic', 'underline']
    const listFormatting = ['numberedList', 'bulletList']
    const linkOption = ['link']

    const result: Array<string | { list: string }>[] = [
        options.filter((option) => textFormatting.includes(option)),
        options
            .filter((option) => listFormatting.includes(option))
            .map((option) => ({
                list: option === 'numberedList' ? 'ordered' : 'bullet',
            })),
        options.filter((option) => linkOption.includes(option)), // Handle 'link' separately
    ]

    return result.filter((group) => group.length > 0)
}
